import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useSelector } from "react-redux";
import APICom from '../../utils/helpers/APICom';
import MultiSelectDropdown from "../Controls/multiselectdropdown";
import { Col, Container, Modal, Row, Button } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import pauseIcon from '@iconify-icons/mdi/pause';
import stopIcon from '@iconify-icons/mdi/stop';
import playIcon from '@iconify-icons/mdi/play';
import ConfirmationModal from '../Controls/ConfirmationModal';

function ARBStatus(props) {
    const [P_MasterASCSCallerIDIframeURL, setP_MasterASCSCallerIDIframeURL] = useState("");
    const { AffiliateData, GlobalASCSData } = useSelector((store) => store.combinedata);
    const [confirmationModalObj, setConfirmationModalObj] = useState({
        show: false, title: 'Auto Routing',
        body: 'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',
        btnOkText: 'Yes'
    });
    const [ARBModalObj, setARBModalObj] = useState({
        show: false, title: 'Auto Routing',
        body: 'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',
        btnOkText: 'Yes'
    });
    const { loginData } = useSelector((store) => store.login);
    const [data, setData] = useState([]);
    const [clusterFilterMultiSelect, setrouteFilterMultiSelect] = useState({ options: [], DropdownMode: 'rS', styles: { width: "98%", marginLeft: "0px" }, selectedValues: [] });
    const [selectedAffiliate, setselectedAffiliate] = useState(parseInt(props.selectedAffiliates));
    const [selectedDescription, setSelectedDescription] = useState();
    const [selectedAffiliateID, setSelectedAffiliateID] = useState();

    let weekDates = [];
    const today = new Date();
    let ARBAutoResumeTimer = 59;
    const [UserAffiliateList, setUserAffiliateList] = useState(
        loginData.UserAffiliateList.split(',').map(id => Number(id))
    );
    useEffect(() => {
        if (GlobalASCSData !== null && GlobalASCSData !== undefined && GlobalASCSData.length > 0) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            setP_MasterASCSCallerIDIframeURL(URL.value.replace('/api', ''));
        }
        else
            setP_MasterASCSCallerIDIframeURL('google.com');
        setupEventListeners();
        fetchData();
    }, []);

    useEffect(() => {
        for (let i = 0; i < 7; i++) {
            const date = new Date(today);
            date.setDate(today.getDate() + i);
            weekDates.push(date);
        }

        if (selectedAffiliate !== "") {
            getARBStatusData(selectedAffiliate);
            setselectedAffiliate(selectedAffiliate)
        }
    }, [selectedAffiliate]);

    const getARBStatusData = async (AffiliateID) => {
        var clusterComboData = [];
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/ARBProcessStatus?AffiliateID=" + AffiliateID + "&ReqDate=" + "1/1/1900", "get", { "Content-Type": "application/json" }, null, null);
        clusterComboData = response.data;

        const dataMap = {};
        clusterComboData.forEach((item) => {
            dataMap[item.dtServiceDate] = item;
        });
        const missingDays = weekDates.filter((date) => !dataMap[date.toDateString()]);

        missingDays.forEach((missingDate) => {
            clusterComboData.push({
                dtServiceDate: missingDate,
                iPauseAutoRouting: 2,
            });
        });
        const uniqueDates = new Set();
        const uniqueData = clusterComboData.filter((item) => {
            const dateStr = new Date(item.dtServiceDate).toDateString();
            if (!uniqueDates.has(dateStr)) {
                uniqueDates.add(dateStr);
                return true;
            }
            return false;
        });
        uniqueData.sort((a, b) => {
            const dateA = new Date(a.dtServiceDate);
            const dateB = new Date(b.dtServiceDate);
            return dateA - dateB;
        });

        setData(uniqueData);
    }

    const fetchData = async () => {
        try {
            let groupOptions = [];
            let filteredAffiliateData = AffiliateData.filter(({ AffiliateID }) => UserAffiliateList.includes(Number(AffiliateID)))
            for (let ii = 0; ii < filteredAffiliateData.length; ii++) {
                groupOptions.push({ "label": filteredAffiliateData[ii].AffiliateCompany, "value": filteredAffiliateData[ii].AffiliateID });
            }
            if (groupOptions.length > 0) {
                setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, options: groupOptions, selectedValues: GetClsuterSelectObjectBy(selectedAffiliate) });
            }

        } catch (ex) {
            console.log(ex);
        }
    };

    const RouteSelectCallback = (_val) => {
        setselectedAffiliate(_val);
        if (_val !== "") {
            setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, ...{ selectedValues: GetClsuterSelectObjectBy(_val) } });
        }
    }

    const GetClsuterSelectObjectBy = (_vVal) => {
        let groupOptions = [];
        for (let ii = 0; ii < AffiliateData.length; ii++) {
            if (AffiliateData[ii].AffiliateID === _vVal) {
                groupOptions.push({ "label": AffiliateData[ii].AffiliateCompany, "value": AffiliateData[ii].AffiliateID });
                break;
            }
        }
        return groupOptions;
    }

    const handleCloseRBSProcessDialog = () => {
        if (props.showRBSProcessDialog) {
            props.setRBSProcessDialog(false);
        }
    }

    const pauseForDate = (date, iPauseAutoRouting, iAffiliateID) => {
        if (iPauseAutoRouting === 0) {
            SaveRBSStatus("Pause", 1, date, iAffiliateID);
        }
        else if (iPauseAutoRouting === 1) {
            SaveRBSStatus("Resume", 0, date, iAffiliateID);
        }
        else {
            UnMountRBSComponent();
        }
    };

    const SaveRBSStatus = async (ServiceStatus, iPauseAutoRouting, dtServiceDate, affilateId, iActionSource = 0) => { //1 = iActionSource Clicked from AutoResume Popup
        try {
            if (ServiceStatus == "StopFromMBPC") {//MBPC screen during Routing

                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + loginData.iUserID, "post", { "Content-Type": "application/json" }, null, null);
            }
            else if (ServiceStatus == "StopFromCallTaker" || ServiceStatus == "ResumedARBAutoRouting") {
                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + loginData.iUserID, "post", { "Content-Type": "application/json" }, null, null);

            } else {
                setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Auto Routing', body: "Are you Sure you want to " + ServiceStatus + " Auto-Routing?", btnCanceText: 'No', btnOkText: 'Yes' }));

                var myData = "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + loginData.iUserID;
                sessionStorage.setItem('ARBProcessStatus', myData);
            }
        } catch (ex) {
            console.log(ex);
        }
    }

    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        UnMountRBSComponent();
    }

    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        //UnMountRBSComponent();
    }

    const UnMountRBSComponent = () => {
        if (props.showRBSProcessDialog) {
            props.setRBSProcessDialog(false);
        }
    }

    const handleConfirmationModalOk = () => {
        var storedDataJSON = sessionStorage.getItem('ARBProcessStatus');
        let response = APICom.fetchData("GenericManifestDotNetCoreURL", storedDataJSON, "post", { "Content-Type": "application/json" }, null, null);
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        UnMountRBSComponent();
    }

    const setupEventListeners = () => {
        try {
            var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
            var eventer = window[eventMethod];
            var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
           // window.addEventListener(messageEvent, ARBResponseListener_RBSProcess);
        }
        catch (ee) {
            console.log('ARBResponseListener Setup Error: ' + ee);
        }
    };

    var lastActivityTimeARBResumedNotification = null;
    const ARBResponseListener_RBSProcess = (ManifestPayLoad) => {
        try {
            let _resp = '';
            console.log(ManifestPayLoad)
            console.log("I am here at ARBResponseListener_RBSProcess")
            if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
                _resp = String(ManifestPayLoad.data);
                if (_resp.indexOf("WMRMSUserMessage=") > -1) {
                    try {
                        var arrtparams = ManifestPayLoad.data.split("||");
                        var args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
                        if (args != "") {
                            try {
                                _resp = JSON.parse(args);
                                var status = _resp.status?.toLowerCase();
                                var message = _resp.message;
                                var iRunID = _resp.run_id;
                                //var caller = ManifestPayLoad.caller.toLowerCase();
                                var bUseViolaionString = _resp.use_violation_string;
                                var violationString = _resp.violation_string;
                                var rsfc_input = _resp.rsfc_input;
                                var objManifestAssignmentHelper = _resp.objManifestAssignmentHelper;
                                var AllAlgoSettings = _resp.AllAlgoSettings;
                                var AllRouteSettings = _resp.AllRouteSettings;
                                var mode = _resp.mode;
                                var auto_routing_enabled = _resp.auto_routing_enabled;
                                var description = _resp.description;
                                var affiliate_id = _resp.affiliate_id;
                                var affiliate_name = _resp.affiliate_name;
                                var user_id = _resp.user_id;
                                let _message = "";

                                if (status == "autoroutingpaused") {
                                    try {
                                        // $("#" + id).addClass("fa-play");
                                        // $("#" + id).removeClass("fa-pause");
                                        // $("#" + id).prop('disable', false);
                                        _message = "Auto Route successfully Paused.";
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }

                                if (status == "autoroutingresumed") {
                                    try {
                                        // $("#divARBStatusBlock").find("#" + id).removeClass("fa-play");
                                        // $("#" + id).addClass("fa-pause");
                                        // $("#" + id).prop('disable', false);
                                        _message = "Auto Route successfully Resumed.";
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }

                                if (status == "arbresumednotification") {
                                    let _secondBetweenTwoDate = 0;
                                    try {
                                        _secondBetweenTwoDate = Math.abs((new Date().getTime() - lastActivityTimeARBResumedNotification.getTime()) / 1000);
                                    } catch (e) {
                                        _secondBetweenTwoDate = 60;
                                    }
                                    if (_secondBetweenTwoDate < 60) {

                                    }
                                    else if (loginData.iUserID == user_id) {
                                        if (ARBAutoResumeTimer === 59) {
                                            setSelectedDescription(description);
                                            setSelectedAffiliateID(affiliate_id);
                                            var _intervalPlaying = setInterval(function () {
                                                if (ARBAutoResumeTimer <= 0) {
                                                    clearInterval(_intervalPlaying);
                                                    setARBModalObj((prevState) => ({ ...prevState, show: false }));
                                                    SaveRBSStatus("ResumedARBAutoRouting", 0, description, affiliate_id, 1);

                                                } else {
                                                    setARBModalObj((prevState) => ({
                                                        ...prevState,
                                                        show: true,
                                                        title: affiliate_name + ` Resume Auto Routing | ${ARBAutoResumeTimer}s`,
                                                        body: `Do you want to Resume Auto-Routing for this date: ${description} ?`,
                                                        btnCanceText: 'No',
                                                        btnOkText: 'Yes'
                                                    }));
                                                    ARBAutoResumeTimer--;
                                                }
                                            }, 1000);
                                        }
                                    }
                                }
                            }
                            catch (ex) {
                                console.log("ARBResponseListener_RBSProcess Error:");
                                console.log(ex);
                            }
                        }
                    }
                    catch (ex) {
                        console.log("ARBResponseListener_RBSProcess Error:");
                        console.log(ex);
                    }
                }
            }
        }
        catch (ex) {
            console.log("ARBResponseListener_RBSProcess Error:");
            console.log(ex);
        }
    }

    const handleCloseButton = () => {
        setARBModalObj((prevState) => ({ ...prevState, show: false }));
        //UnMountRBSComponent();
    }
    const handleYesButton = () => {
        SaveRBSStatus("ResumedARBAutoRouting", 0, selectedDescription, selectedAffiliateID, 1);//1 form AutoResume Popup
        setARBModalObj((prevState) => ({ ...prevState, show: false }));
        UnMountRBSComponent();
    }
    const handleNoButton = () => {
        SaveRBSStatus("ResumedARBAutoRouting", 2, selectedDescription, selectedAffiliateID, 1); //iPauseAutoRouting=2: When User click on No button, 1 form AutoResume Popup
        setARBModalObj((prevState) => ({ ...prevState, shsow: false }));
        UnMountRBSComponent();
    }

    return (
        <>
            <Modal show={props.setRBSProcessDialog ? 1 : 0} centered onHide={handleCloseRBSProcessDialog} backdrop={"static"} keyboard={true} animation={true} size="lg"
                aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header className='dispatch_action_dialog_header_bgcolor' closeButton>
                    <Modal.Title className='dispatch_action_dialog_title_color user-select-none' id="contained-modal-title-vcenter">
                        RBS Process
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example user-select-none">
                    <Container>
                        <Row className="pt-2">
                            <Col md={2} className="d-flex">
                                <label>Affiliate:</label>
                            </Col>
                            <Col md={5} className="d-flex">
                                <MultiSelectDropdown options={clusterFilterMultiSelect} showCheckbox={false} className="w-100" SelectionChangeCallback={RouteSelectCallback} />
                            </Col>
                            {/* <Col md={5} className="d-flex">
                                <Button href="#" variant="primary" size="md">
                                    RBS Detail Execution
                                </Button>
                            </Col>*/}
                           
                        </Row>
                    </Container>
                    <Container>
                        <br></br>
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        {data.map((item, index) => (
                                            <td key={index} style={{ fontWeight: 'bold', paddingRight: '10px' }}>
                                                {moment(item.dtServiceDate).format('MM/DD (ddd)')}
                                            </td>
                                        ))}
                                    </tr>
                                    <tr>
                                        {data.map((item, index) => (
                                        <td key={index}>
                                            <span
                                                onClick={() => pauseForDate(item.dtServiceDate, item.iPauseAutoRouting, item.iAffiliateID)}
                                                style={{ cursor: 'pointer' }}
                                                className="mr-2"
                                                title={item?.msg}
                                            >
                                                <Icon
                                                    icon={
                                                        item.iPauseAutoRouting === 0
                                                            ? pauseIcon
                                                            : item.iPauseAutoRouting === 1
                                                                ? playIcon
                                                                : stopIcon
                                                    }
                                                    width={32}
                                                    height={32}
                                                    color={
                                                        item.iPauseAutoRouting === 0
                                                            ? 'orange'
                                                            : item.iPauseAutoRouting === 1
                                                                ? 'green'
                                                                : 'red'
                                                    }
                                                />
                                            </span>
                                            {item.msg && (
                                                <span className="ml-2" title={item?.msg} style={{ cursor: 'pointer' }}>
                                                    <Icon icon="mdi:information-outline" width={20} height={20} color="#ADD8E6" />
                                                </span>
                                            )}
                                        </td>
                                    ))}
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </Container>
                </Modal.Body>

            </Modal>

            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
                onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose} btnCanceText={confirmationModalObj.btnCanceText}
                btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="true" />

            <ConfirmationModal centered  // Add the centered prop
                aria-labelledby="contained-modal-title-vcenter" show={ARBModalObj.show} Title={ARBModalObj.title} Body={ARBModalObj.body}
                onOk={handleYesButton} onCancel={handleNoButton} onClose={handleCloseButton} btnCanceText={ARBModalObj.btnCanceText}
                btnOkText={ARBModalObj.btnOkText} ShowCancelButton="true" />

        </>
    );
}

export default ARBStatus;
